export default __webpack_public_path__ + "static/media/icon-user.d9497c9b.svg";